module.exports = __webpack_public_path__ + "img/topback@2x.c8ba82e8.png";